import { render } from "./PointOfSale.vue?vue&type=template&id=568fff40&scoped=true"
import script from "./PointOfSale.vue?vue&type=script&lang=js"
export * from "./PointOfSale.vue?vue&type=script&lang=js"

import "./PointOfSale.vue?vue&type=style&index=0&id=568fff40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568fff40"]])

export default __exports__